export enum FeatureToggle {
  searchPlatform = 'rt_search_platform',
}
